import { Col, Spinner } from "react-bootstrap";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";
import { SelectedChannelsProvider } from "../../context/selectedChannels";
import { ChannelContextProvider } from "../../context/channels";

const RelatedChannels = ({
  currentChannelId,
  relatedChannels = [],
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="related-channels-container">
        <div className="related-channels-header">
          <h5>کانال‌های هم سو</h5>
        </div>
        <div className="text-center p-4">
          <Spinner animation="border" />
        </div>
      </div>
    );
  }

  if (!relatedChannels.length) {
    return null;
  }

  return (
    <div className="related-channels-container">
      <div className="related-channels-header">
        <h5>کانال‌های هم سو</h5>
      </div>
      <div className="related-channels-list">
        {relatedChannels?.map((item, index) => (
          <Col xl={3} sm={6} xs={12} className="mb-3" key={index}>
            <div key={index}>
              <SelectedChannelsProvider>
                <ChannelContextProvider>
                  <ChannelCard
                    total_video_count={item?.total_video_count}
                    imgSrc={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.avatar
                        : item.from_channel.avatar
                    }
                    views={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.counted_view || 0
                        : item.from_channel.counted_view || 0
                    }
                    videoViews={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.total_video_views || 0
                        : item.from_channel.total_video_views || 0
                    }
                    channelName={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.name
                        : item.from_channel.name
                    }
                    subscriberCount={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.subscribe_count || 0
                        : item.from_channel.subscribe_count || 0
                    }
                    videosId={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.name
                        : item.from_channel.name
                    }
                    imgHref={`/single-channel/${
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.id
                        : item.from_channel.id
                    }`}
                    channelHref={`/single-channel/${
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.id
                        : item.from_channel.id
                    }`}
                    channelId={
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.id
                        : item.from_channel.id
                    }
                    moreAdress={`/myVideos/${
                      item.from_channel.id === currentChannelId
                        ? item.to_channel.id
                        : item.from_channel.id
                    }`}
                  />
                </ChannelContextProvider>
              </SelectedChannelsProvider>
            </div>
          </Col>
        ))}
      </div>
    </div>
  );
};

export default RelatedChannels;
